import React from 'react';
import { Badge } from '../ui/badge';

export const BancoSponsorBadge = ({ banco, testid }) => {
  if (!banco) return <Badge className="text-[10px] px-1.5 py-0 bg-slate-100 text-slate-500" data-testid={testid}>Sponsor desconocido</Badge>;
  return (
    <Badge className={`text-[10px] px-1.5 py-0 ${banco.activo ? 'bg-emerald-100 text-emerald-800' : 'bg-slate-200 text-slate-600'}`} data-testid={testid}>
      {banco.nombre}{banco.activo ? '' : ' · sponsor anterior'}
    </Badge>
  );
};

export const ReemplazadoBadge = ({ cvu, testid }) => {
  if (!cvu.reemplazado_por) return null;
  return cvu.reemplazado_sigue_activo
    ? <Badge className="text-[10px] px-1.5 py-0 bg-amber-100 text-amber-800" data-testid={testid}>Reemplazado, sigue activo</Badge>
    : <Badge className="text-[10px] px-1.5 py-0 bg-slate-200 text-slate-600" data-testid={testid}>Reemplazado</Badge>;
};

export const CvuReemplazoInfo = ({ cvu, idx }) => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-2 px-4 py-2 bg-white border-t border-slate-100 text-xs" data-testid={`cvu-reemplazo-info-${idx}`}>
    <div>
      <span className="text-slate-400 block">Banco sponsor</span>
      <span className="font-medium text-slate-700" data-testid={`cvu-banco-sponsor-${idx}`}>
        {cvu.banco_sponsor ? `${cvu.banco_sponsor.nombre}${cvu.banco_sponsor.activo ? '' : ' (anterior)'}` : 'Desconocido'}
      </span>
    </div>
    <div>
      <span className="text-slate-400 block">Reemplaza a</span>
      {cvu.reemplaza_a ? (
        <span data-testid={`cvu-reemplaza-a-${idx}`}>
          <span className="font-mono text-slate-700">{cvu.reemplaza_a}</span>
          {cvu.motivo_cambio && <span className="block text-slate-500">Motivo: {cvu.motivo_cambio}</span>}
        </span>
      ) : <span className="text-slate-400" data-testid={`cvu-reemplaza-a-${idx}`}>—</span>}
      {cvu.reemplazado_por && <span className="block text-slate-500">Reemplazado por <span className="font-mono">{cvu.reemplazado_por}</span></span>}
    </div>
    <div>
      <span className="text-slate-400 block">Origen</span>
      <span className="font-medium text-slate-700" data-testid={`cvu-origen-${idx}`}>{cvu.origen_label || 'Padrón'}</span>
    </div>
  </div>
);
